import { SECTION_NAMES } from '../actions/types'

const initialState = []

const sectionDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SECTION_NAMES:
      return action.payload
    default:
      return state
  }
}

export default sectionDataReducer
